<template>
    <div class="quiz__campaign-endpoint-blocks">
        <div class="block-sizer"></div>
        <div v-for="(block, block_key) in blocks" :id="'content_block_' + block.id" :key="'block_' + block_key" :class="'block quiz__campaign__'+ block.key">
            <qc-video v-if="block.key == 'endpoint_video'" :content="block"></qc-video>
            <qc-images v-if="block.key == 'endpoint_images'" :content="block"></qc-images>
            <qc-spotify v-if="block.key == 'endpoint_spotify'" :endpoint="endpoint" :campaign="campaign" :content="block" :spotifyshare="spotifyshare"></qc-spotify>
            <qc-article v-if="block.key == 'endpoint_article'" :content="block"></qc-article>
            <qc-endpoint v-if="block.key == 'endpoint_endpoint'" :content="block"></qc-endpoint>
            <qc-startagain v-if="block.key == 'endpoint_startagain'" :campaign="campaign" :content="block"></qc-startagain>
            <qc-products v-if="block.key == 'endpoint_products'" :content="block" :shopconfig="shopconfig"></qc-products>
            <qc-share v-if="block.key == 'endpoint_share'" :endpoint="endpoint" :campaign="campaign" :content="block" :shopconfig="shopconfig"></qc-share>
        </div>
    </div>
</template>
<script>

import QcArticle from './content-blocks/article';
import QcEndpoint from './content-blocks/endpoint';
import QcImages from './content-blocks/images';

import QcProducts from './content-blocks/related-products';
import QcShare from './content-blocks/share';
import QcSpotify from './content-blocks/spotify';
import QcStartagain from './content-blocks/start-again';
import QcVideo from './content-blocks/video';

export default {
    props: ['blocks','campaign', 'endpoint', 'shopconfig','spotifyshare'],
    components: {
        QcArticle,
        QcEndpoint,
        QcImages,
        QcProducts,
        QcShare,
        QcSpotify,
        QcStartagain,
        QcVideo
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/endpoint-blocks.vue